import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const B3Logo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M.98 5.3h10.506c.19 0 .344.148.344.331v4.738c0 .296-.18.564-.458.687l-1.324.585a.176.176 0 0 0-.106.16c0 .067.04.128.104.157l1.335.612c.274.125.449.39.449.683v5.117a.338.338 0 0 1-.344.331H.979c-.54 0-.979-.422-.979-.942V6.242c0-.52.439-.942.98-.942Zm5.698 8.934c.268 0 .459-.035.572-.104.124-.07.186-.198.186-.387v-.03c0-.198-.067-.338-.201-.417-.124-.08-.336-.119-.634-.119H4.64v1.057h2.037Zm-.093-3.618c.475 0 .712-.164.712-.492v-.074c0-.189-.062-.318-.185-.387-.114-.08-.305-.12-.573-.12H4.642v1.073h1.944Zm6.135 2.517h4.33c0 .337.062.57.185.7.135.129.325.193.573.193.423 0 .634-.233.634-.7 0-.228-.072-.392-.216-.491-.135-.1-.34-.15-.62-.15h-2.382v-1.727l3.667-.878h-6.17a.307.307 0 0 1-.313-.3V5.55c0-.137.117-.25.261-.25h10.15c.542 0 .98.422.98.942v3.38a.832.832 0 0 1-.658.802l-4.018.922.185.03h3.835c.473 0 .857.37.857.825v5.558c0 .52-.438.943-.98.943H12.67a.256.256 0 0 1-.26-.251v-5.018c0-.166.14-.3.311-.3Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};